import axios from 'axios';
(function ($) {
    RVwys.isButton = false;

    RVwys.buttonInsert = {};
    RVwys.buttonInsert.configure = {};

    RVwys.buttonInsert.sClass = {};

    RVwys.buttonInsert.configure['background'] = {
        background: '',
        gradient: '',
        angle: '',
        leftColor: '',
        rightColor: '',
    };

    RVwys.buttonInsert.configure['prop'] = {
        border: '',
        color: '',
        'border-color': '',
        'border-size': '',
        'border-style': '',
        padding: '',
        top: '',
        right: '',
        bottom: '',
        left: '',
        'border-radius': '',
    };

    RVwys.buttonInsert.configure['text-shadow'] = {
        'text-shadow': '',
        color: '',
        horizontal: '',
        vertical: '',
        'blur-radius': '',
    };

    RVwys.buttonInsert.configure['box-shadow'] = {
        'box-shadow': '',
        color: '',
        horizontal: '',
        vertical: '',
        'blur-radius': '',
        'spread-radius': '',
    };

    RVwys.buttonInsert['style'] = {
        padding: '',
        border: '',
        'border-color': '',
        'border-radius': '',
        background: '',
        'text-shadow': '',
        'box-shadow': '',
    };

    RVwys.buttonInsert.appendCssToBody = (TagHeader, json) => {
        const css = CSSJSON.toCSS(json);
        const styleButton = $(
            '<style type="text/css" id="button_style"></style>'
        ).append(css);
        TagHeader.append(styleButton);
    };

    RVwys.buttonInsert.handlePanel = curTab => {
        parent.$('.wys-buttonInsert').show();

        //Slider
        parent.$('.range-slider-active').slider({
            slide: sliderChanged,
        });

        parent
            .$('#button-setting-prop-horipadding')
            .slider('option', { min: 0, max: 80 });
        parent
            .$('#button-setting-prop-vertpadding')
            .slider('option', { min: 0, max: 40 });
        parent
            .$('#button-setting-prop-borderradius')
            .slider('option', { min: 0, max: 180 });
        parent
            .$('#button-setting-prop-bordersize')
            .slider('option', { min: 0, max: 50 });
        parent
            .$('#button-setting-ts-vertposition')
            .slider('option', { min: -10, max: 10 });
        parent
            .$('#button-setting-ts-horiposition')
            .slider('option', { min: -10, max: 10 });
        parent
            .$('#button-setting-ts-blurradius')
            .slider('option', { min: 0, max: 10 });
        parent
            .$('#button-setting-bs-vertposition')
            .slider('option', { min: -80, max: 80 });
        parent
            .$('#button-setting-bs-horiposition')
            .slider('option', { min: -80, max: 80 });
        parent
            .$('#button-setting-bs-blurradius')
            .slider('option', { min: 0, max: 80 });
        parent
            .$('#button-setting-bs-spreadradius')
            .slider('option', { min: 0, max: 10 });

        parent.$('.Input-slide-section').change(e => {
            switch (e.target.id) {
                case 'set-prop-HPSection':
                    parent.RVwys.buttonInsert.configure['prop']['right'] = $(
                        e.target
                    ).val();
                    break;
                case 'set-prop-VPSection':
                    parent.RVwys.buttonInsert.configure['prop']['top'] = $(
                        e.target
                    ).val();
                    break;
                case 'set-prop-BRSection':
                    parent.RVwys.buttonInsert.configure['prop'][
                        'border-radius'
                    ] = $(e.target).val();
                    break;
                case 'set-prop-BSSection':
                    parent.RVwys.buttonInsert.configure['prop'][
                        'border-size'
                    ] = $(e.target).val();
                    break;
                case 'set-ts-VPSection':
                    parent.RVwys.buttonInsert.configure['text-shadow'][
                        'vertical'
                    ] = $(e.target).val();
                    break;
                case 'set-ts-VPSection':
                    parent.RVwys.buttonInsert.configure['text-shadow'][
                        'vertical'
                    ] = $(e.target).val();
                    break;
                case 'set-ts-HPSection':
                    parent.RVwys.buttonInsert.configure['text-shadow'][
                        'horizontal'
                    ] = $(e.target).val();
                    break;
                case 'set-ts-BRSection':
                    parent.RVwys.buttonInsert.configure['text-shadow'][
                        'blur-radius'
                    ] = $(e.target).val();
                    break;
                case 'set-bs-VPSection':
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'vertical'
                    ] = $(e.target).val();
                    break;
                case 'set-bs-HPSection':
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'horizontal'
                    ] = $(e.target).val();
                    break;
                case 'set-bs-BRSection':
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'blur-radius'
                    ] = $(e.target).val();
                    break;
                case 'set-bs-SRSection':
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'spread-radius'
                    ] = $(e.target).val();
                    break;
                default:
                    break;
            }
            RVwys.buttonInsert.styleToButton();
        });

        function sliderChanged(e, ui) {
            switch (e.target.id) {
                case 'button-setting-prop-horipadding':
                    parent.$('#set-prop-HPSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['prop']['right'] =
                        ui.value;
                    break;
                case 'button-setting-prop-vertpadding':
                    parent.$('#set-prop-VPSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['prop']['top'] =
                        ui.value;
                    break;
                case 'button-setting-prop-borderradius':
                    parent.$('#set-prop-BRSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['prop'][
                        'border-radius'
                    ] = ui.value;
                    break;
                case 'button-setting-prop-bordersize':
                    parent.$('#set-prop-BSSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['prop']['border-size'] =
                        ui.value;
                    break;
                case 'button-setting-ts-vertposition':
                    parent.$('#set-ts-VPSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['text-shadow'][
                        'vertical'
                    ] = ui.value;
                    break;
                case 'button-setting-ts-horiposition':
                    parent.$('#set-ts-HPSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['text-shadow'][
                        'horizontal'
                    ] = ui.value;
                    break;
                case 'button-setting-ts-blurradius':
                    parent.$('#set-ts-BRSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['text-shadow'][
                        'blur-radius'
                    ] = ui.value;
                    break;
                case 'button-setting-bs-vertposition':
                    parent.$('#set-bs-VPSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'vertical'
                    ] = ui.value;
                    break;
                case 'button-setting-bs-horiposition':
                    parent.$('#set-bs-HPSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'horizontal'
                    ] = ui.value;
                    break;
                case 'button-setting-bs-blurradius':
                    parent.$('#set-bs-BRSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'blur-radius'
                    ] = ui.value;
                    break;
                case 'button-setting-bs-spreadradius':
                    parent.$('#set-bs-SRSection').val(ui.value);
                    parent.RVwys.buttonInsert.configure['box-shadow'][
                        'spread-radius'
                    ] = ui.value;
                    break;
                default:
                    break;
            }

            RVwys.buttonInsert.styleToButton();
        }

        // Color picker
        parent.$('.b-picker').spectrum({
            showInput: true,
            allowEmpty: true,
            showAlpha: true,
            preferredFormat: 'rgb',
            hide: function (color) {
                RVwys.buttonInsert.setColor($(this).attr('id'), color);
            },
            move: function (color) {
                RVwys.buttonInsert.setColor($(this).attr('id'), color);
            },
        });

        //set tabs
        if (curTab === 'setting')
            parent.$('.Insertbtn-element').tabs({ active: 1 });
        else if (curTab === 'design')
            parent.$('.Insertbtn-element').tabs({ active: 0 });

        parent.$('a[data-toggle="mode-setting"]').click(function () {
            //get style inline to object
            if (parent.RVwys.isButton) {
                let style = {};
                const attr = parent.RVwys.isButton.attr('style');

                if (typeof attr !== typeof undefined && attr !== false)
                    style = CSSJSON.toJSONliteral(attr);
                else style = false;

                RVwys.buttonInsert.clearSettingConfigure();
                RVwys.buttonInsert.getAttrClass(
                    parent.RVwys.isButton.prop('class').split(' '),
                    style
                );
                RVwys.buttonInsert.configureToSetting();
            }
        });

        parent.$('a[data-toggle="mode-title"]').click(function () {
            if (parent.RVwys.isButton) {
                parent.$('.ui-button-title').val(parent.RVwys.isButton.html());
            }
            parent
                .$('#auto-size')
                .on('change keyup keydown paste cut', 'textarea', function () {
                    $(this).height(0).height(this.scrollHeight);
                })
                .find('textarea')
                .change();
        });

        parent
            .$('#auto-size')
            .on('change keyup keydown paste cut', 'textarea', function () {
                $(this).height(0).height(this.scrollHeight);
            })
            .find('textarea')
            .change();

        //choose color group base color
        parent.$('div.colorgroup span.sample-button').click(function (e) {
            const getColor = $(e.target).data('color');
            parent
                .$('.b-picker#setColor,.b-picker#setColors')
                .spectrum('set', getColor);
            parent.RVwys.buttonInsert.configure['background'] = {
                ...parent.RVwys.buttonInsert.configure['background'],
                leftColor: getColor,
                rightColor: getColor,
            };

            RVwys.buttonInsert.styleToButton();
        });
    };

    RVwys.buttonInsert.setColor = (id, color) => {
        color === null
            ? (color = 'rgba(255, 255, 255, 0)')
            : (color = color.toRgbString());
        switch (id) {
            case 'setColor':
                parent.RVwys.buttonInsert.configure['background'][
                    'leftColor'
                ] = color;
                break;
            case 'setColors':
                parent.RVwys.buttonInsert.configure['background'][
                    'rightColor'
                ] = color;
                break;
            case 'setbsColor':
                parent.RVwys.buttonInsert.configure['box-shadow'][
                    'color'
                ] = color;
                break;
            case 'setbcColor':
                (parent.RVwys.buttonInsert.configure['prop']['color'] = color),
                    (parent.RVwys.buttonInsert.configure['prop'][
                        'border-color'
                    ] = color);
                break;
            case 'settsColor':
                parent.RVwys.buttonInsert.configure['text-shadow'][
                    'color'
                ] = color;
                break;
            default:
                break;
        }

        RVwys.buttonInsert.styleToButton();
    };

    RVwys.buttonInsert.styleToButton = () => {
        //destructuring object
        const {
                leftColor,
                rightColor,
                angle,
                gradient,
            } = parent.RVwys.buttonInsert.configure['background'],
            //prop
            {
                color: pColorBorder,
                'border-color': pColorBorders,
                right: pHorizontal,
                top: pVertical,
                bottom: pBottom,
                left: pLeft,
                'border-radius': pBorderRadius,
                'border-size': pBorderSize,
                'border-style': pBorderStyle,
            } = parent.RVwys.buttonInsert.configure['prop'],
            //text shadow
            {
                color: tsColor,
                horizontal: tsHorizontal,
                vertical: tsVertical,
                'blur-radius': tsBlurRadius,
            } = parent.RVwys.buttonInsert.configure['text-shadow'],
            //box shadow
            {
                color: bsColor,
                horizontal: bsHorizontal,
                vertical: bsVertical,
                'blur-radius': bsBlurRadius,
                'spread-radius': bsSpreadRadius,
            } = parent.RVwys.buttonInsert.configure['box-shadow'];

        parent.RVwys.buttonInsert['style'] = {
            ...parent.RVwys.buttonInsert['style'],
            background:
                angle === ''
                    ? `linear-gradient(${leftColor}, ${rightColor})`
                    : `${gradient}-gradient(${angle}, ${leftColor}, ${rightColor})`,
            'border-radius': `${pBorderRadius}px`,
            border: `${pBorderSize}px ${
                pBorderStyle === '' ? 'solid' : pBorderStyle
            } ${pColorBorder}`,
            'border-color': pColorBorders === '' ? pColorBorder : pColorBorders,
            padding: `${pVertical}px ${pHorizontal}px ${
                pBottom === '0' ? '' : pBottom + 'px'
            } ${pLeft === '0' ? '' : pLeft + 'px'}`,
            'text-shadow': `${tsColor} ${tsHorizontal}px ${tsVertical}px ${tsBlurRadius}px`,
            'box-shadow': `${bsColor} ${bsHorizontal}px ${bsVertical}px ${bsBlurRadius}px ${bsSpreadRadius}px`,
        };

        // console.log('============styleToButton===========')
        // console.log(parent.RVwys.buttonInsert.style)
        // console.log('====================================')

        parent.RVwys.isButton.css(parent.RVwys.buttonInsert.style);
    };

    RVwys.buttonInsert.getAttrClass = (sClass, inline) => {
        const attrClass = parent.RVwys.buttonInsert.sClass.children;

        let storeAttr = {},
            re = '',
            isStatus = false,
            C = '';

        // console.log('===========getStyleFile=============')
        // console.log(attrClass)
        // console.log('====================================')

        // console.log('=============getClass===============')
        // console.log(sClass)
        // console.log('====================================')

        // console.log('=============getinline==============')
        // console.log(!inline ? inline : inline['attributes'])
        // console.log('====================================')

        sClass.map(state => {
            isStatus = false;
            let ClsPoint;

            state === 'rv-button-oval'
                ? (ClsPoint = `a.${state}`)
                : (ClsPoint = `.${state}`);

            Object.keys(attrClass).map(key => {
                if (ClsPoint === key && ClsPoint !== '.rv-button') {
                    // console.log(`1--->${key}`)
                    storeAttr = {
                        ...storeAttr,
                        ...attrClass[key]['attributes'],
                    };
                    isStatus = true;
                } else if (!isStatus) {
                    re = new RegExp(`^${ClsPoint},.*$`);
                    if (key.match(re)) {
                        // console.log(`2--->${key}`)
                        storeAttr = {
                            ...storeAttr,
                            ...attrClass[key]['attributes'],
                        };
                    }
                }
            });
        });

        // console.log('============getAttrClass============')
        // console.log(storeAttr)
        // console.log('====================================')

        //spread operator {merge object}
        if (inline) storeAttr = { ...storeAttr, ...inline['attributes'] };

        // console.log('========getAttrClass[merge]=========')
        // console.log(storeAttr)
        // console.log('====================================')

        RVwys.buttonInsert.reverseToConfig(storeAttr);
    };

    RVwys.buttonInsert.reverseToConfig = attr => {
        Object.keys(RVwys.buttonInsert.configure).map(key0 => {
            Object.keys(RVwys.buttonInsert.configure[key0]).map(key1 => {
                Object.keys(attr).map(key2 => {
                    if (key1 === key2 && key2 !== 'color') {
                        switch (key0) {
                            case 'background':
                                if (attr[key2].match(/-gradient/)) {
                                    const {
                                        angle,
                                        leftColor,
                                        rightColor,
                                    } = RVwys.buttonInsert.splitStyle(
                                        attr[key2]
                                    );
                                    parent.RVwys.buttonInsert.configure[
                                        'background'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'background'
                                        ],
                                        background: attr[key2],
                                        gradient: attr[key2].match(
                                            /linear-gradient/
                                        )
                                            ? 'linear'
                                            : 'radial',
                                        angle: angle,
                                        leftColor: leftColor,
                                        rightColor: rightColor,
                                    };
                                } else {
                                    parent.RVwys.buttonInsert.configure[
                                        'background'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'background'
                                        ],
                                        background: attr[key2],
                                        leftColor: attr[key2],
                                        rightColor: attr[key2],
                                    };
                                }
                                break;
                            case 'prop':
                                if (key2 === 'border') {
                                    const [
                                        p1,
                                        p2,
                                        p3,
                                    ] = RVwys.buttonInsert.splitStyle(
                                        attr[key2]
                                    );
                                    parent.RVwys.buttonInsert.configure[
                                        'prop'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'prop'
                                        ],
                                        border: attr[key2],
                                        color: p3,
                                        'border-size': p1,
                                        'border-style': p2,
                                    };
                                } else if (key2 === 'padding') {
                                    const [
                                        p1,
                                        p2,
                                        p3,
                                        p4,
                                    ] = RVwys.buttonInsert.splitStyle(
                                        attr[key2]
                                    );
                                    parent.RVwys.buttonInsert.configure[
                                        'prop'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'prop'
                                        ],
                                        padding: attr[key2],
                                        top: p1,
                                        right:
                                            typeof p2 !== 'undefined'
                                                ? p2
                                                : '0',
                                        bottom:
                                            typeof p3 !== 'undefined'
                                                ? p3
                                                : '0',
                                        left:
                                            typeof p4 !== 'undefined'
                                                ? p4
                                                : '0',
                                    };
                                } else if (key2 === 'border-radius') {
                                    const [p1] = RVwys.buttonInsert.splitStyle(
                                        attr[key2]
                                    );
                                    parent.RVwys.buttonInsert.configure[
                                        'prop'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'prop'
                                        ],
                                        'border-radius': p1,
                                    };
                                } else {
                                    parent.RVwys.buttonInsert.configure[
                                        'prop'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'prop'
                                        ],
                                        'border-color': attr[key2],
                                    };
                                }
                                break;
                            case 'box-shadow':
                                if (key2 === 'box-shadow') {
                                    const [
                                        p1,
                                        p2,
                                        p3,
                                        p4,
                                        p5,
                                    ] = RVwys.buttonInsert.splitStyle(
                                        attr[key2]
                                    );
                                    parent.RVwys.buttonInsert.configure[
                                        'box-shadow'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'box-shadow'
                                        ],
                                        'box-shadow': attr[key2],
                                        color: p1,
                                        vertical: p3,
                                        horizontal: p2,
                                        'blur-radius': p4,
                                        'spread-radius': p5,
                                    };
                                }
                                break;
                            case 'text-shadow':
                                if (key2 === 'text-shadow') {
                                    const [
                                        p1,
                                        p2,
                                        p3,
                                        p4,
                                    ] = RVwys.buttonInsert.splitStyle(
                                        attr[key2]
                                    );
                                    parent.RVwys.buttonInsert.configure[
                                        'text-shadow'
                                    ] = {
                                        ...parent.RVwys.buttonInsert.configure[
                                            'text-shadow'
                                        ],
                                        'text-shadow': attr[key2],
                                        color: p1,
                                        vertical: p3,
                                        horizontal: p2,
                                        'blur-radius': p4,
                                    };
                                }
                                break;
                            default:
                                break;
                        }
                    }
                });
            });
        });

        // console.log('=========reverseToConfig============')
        // console.log(parent.RVwys.buttonInsert.configure)
        // console.log('====================================')
    };

    RVwys.buttonInsert.resetToDefault = () => {
        $(RVwys.isButton).removeAttr('style');
        RVwys.buttonInsert.clearSettingConfigure();
        RVwys.buttonInsert.getAttrClass(
            parent.RVwys.isButton.prop('class').split(' '),
            false
        );
        RVwys.buttonInsert.configureToSetting();
    };

    RVwys.buttonInsert.configureToSetting = () => {
        //destructuring object
        let { leftColor, rightColor } = parent.RVwys.buttonInsert.configure[
                'background'
            ],
            //prop
            {
                color: pColorBorder,
                'border-color': pColorBorders,
                right: pHorizontal,
                top: pVertical,
                'border-radius': pBorderRadius,
                'border-size': pBorderSize,
            } = parent.RVwys.buttonInsert.configure['prop'],
            //text shadow
            {
                color: tsColor,
                horizontal: tsHorizontal,
                vertical: tsVertical,
                'blur-radius': tsBlurRadius,
            } = parent.RVwys.buttonInsert.configure['text-shadow'],
            //box shadow
            {
                color: bsColor,
                horizontal: bsHorizontal,
                vertical: bsVertical,
                'blur-radius': bsBlurRadius,
                'spread-radius': bsSpreadRadius,
            } = parent.RVwys.buttonInsert.configure['box-shadow'];

        parent.$('.b-picker#setColor').spectrum('set', leftColor);
        parent.$('.b-picker#setColors').spectrum('set', rightColor);

        parent
            .$('#button-setting-prop-horipadding')
            .slider('option', { value: pHorizontal }),
            parent.$('#set-prop-HPSection').val(pHorizontal);
        parent
            .$('#button-setting-prop-vertpadding')
            .slider('option', { value: pVertical }),
            parent.$('#set-prop-VPSection').val(pVertical);
        parent
            .$('#button-setting-prop-borderradius')
            .slider('option', { value: pBorderRadius }),
            parent.$('#set-prop-BRSection').val(pBorderRadius);
        parent
            .$('#button-setting-prop-bordersize')
            .slider('option', { value: pBorderSize }),
            parent.$('#set-prop-BSSection').val(pBorderSize);
        parent
            .$('.b-picker#setbcColor')
            .spectrum(
                'set',
                pColorBorders === '' ? pColorBorder : pColorBorders
            );

        parent
            .$('#button-setting-ts-vertposition')
            .slider('option', { value: tsVertical }),
            parent.$('#set-ts-VPSection').val(tsVertical);
        parent
            .$('#button-setting-ts-horiposition')
            .slider('option', { value: tsHorizontal }),
            parent.$('#set-ts-HPSection').val(tsHorizontal);
        parent
            .$('#button-setting-ts-blurradius')
            .slider('option', { value: tsBlurRadius }),
            parent.$('#set-ts-BRSection').val(tsBlurRadius);
        parent.$('.b-picker#settsColor').spectrum('set', tsColor);

        parent
            .$('#button-setting-bs-vertposition')
            .slider('option', { value: bsVertical }),
            parent.$('#set-bs-VPSection').val(bsVertical);
        parent
            .$('#button-setting-bs-horiposition')
            .slider('option', { value: bsHorizontal }),
            parent.$('#set-bs-HPSection').val(bsHorizontal);
        parent
            .$('#button-setting-bs-blurradius')
            .slider('option', { value: bsBlurRadius }),
            parent.$('#set-bs-BRSection').val(bsBlurRadius);
        parent
            .$('#button-setting-bs-spreadradius')
            .slider('option', { value: bsSpreadRadius }),
            parent.$('#set-bs-SRSection').val(bsSpreadRadius);
        parent.$('.b-picker#setbsColor').spectrum('set', bsColor);
    };

    RVwys.buttonInsert.splitStyle = obj => {
        if (obj.match(/-gradient/)) {
            const angles = /\(([0-9a-zA-Z\s]+)/,
                PattenColor = /((rgba|rgb)\(([0-9\,\.\s]+)\))/gm;
            let xx = { angle: '', leftColor: '', rightColor: '' };
            xx = {
                ...xx,
                angle:
                    obj.match(angles)[1] === 'rgb' ||
                    obj.match(angles)[1] === 'rgba'
                        ? ''
                        : `${obj.match(angles)[1]}`,
                leftColor: obj.match(PattenColor)[0],
                rightColor: obj.match(PattenColor)[1],
            };
            return xx;
        }
        const xx = obj.match(
            /(-?\d+)|(d.....|solid)|(rgba\(.+\))|(rgb\(.+\))/g
        );
        return xx;
    };

    RVwys.buttonInsert.clearSettingConfigure = () => {
        parent.RVwys.buttonInsert.configure['background'] = {
            ...parent.RVwys.buttonInsert.configure['background'],
            background: '',
            gradient: '',
            angle: '',
            leftColor: '',
            rightColor: '',
        };
        parent.RVwys.buttonInsert.configure['prop'] = {
            ...parent.RVwys.buttonInsert.configure['prop'],
            border: '0',
            color: '',
            'border-color': '',
            'border-size': '0',
            'border-style': '',
            padding: '',
            top: '1',
            right: '5',
            bottom: '0',
            left: '0',
            'border-radius': '0',
        };

        parent.RVwys.buttonInsert.configure['text-shadow'] = {
            ...parent.RVwys.buttonInsert.configure['text-shadow'],
            'text-shadow': '',
            color: 'rgba(0, 0, 0, 0.3)',
            horizontal: '0',
            vertical: '0',
            'blur-radius': '0',
        };

        parent.RVwys.buttonInsert.configure['box-shadow'] = {
            ...parent.RVwys.buttonInsert.configure['box-shadow'],
            'box-shadow': '',
            color: 'rgba(0, 0, 0, 0.3)',
            horizontal: '0',
            vertical: '0',
            'blur-radius': '0',
            'spread-radius': '0',
        };

        parent.RVwys.buttonInsert['style'] = {
            ...parent.RVwys.buttonInsert['style'],
            padding: '',
            border: '',
            'border-color': '',
            'border-radius': '',
            background: '',
            'text-shadow': '',
            'box-shadow': '',
        };

        // Object.keys(parent.RVwys.buttonInsert['style']).map(key => parent.RVwys.buttonInsert['style'][key] = "")
        // Object.keys(parent.RVwys.buttonInsert.configure['prop']).map(key =>
        //     key === 'color' || key === 'border-color' ? parent.RVwys.buttonInsert.configure['prop'][key] = "" : parent.RVwys.buttonInsert.configure['prop'][key] = 0
        //     )
        // Object.keys(parent.RVwys.buttonInsert.configure['text-shadow']).map(key =>
        //     key === 'color' ? parent.RVwys.buttonInsert.configure['text-shadow'][key] = "" : parent.RVwys.buttonInsert.configure['text-shadow'][key] = 0
        // )
        // Object.keys(parent.RVwys.buttonInsert.configure['box-shadow']).map(key =>
        //     key === 'color' ? parent.RVwys.buttonInsert.configure['box-shadow'][key] = "" : parent.RVwys.buttonInsert.configure['box-shadow'][key] = 0
        // )
        // Object.keys(parent.RVwys.buttonInsert.configure['background']).map(key => parent.RVwys.buttonInsert.configure['background'][key] = "")
    };

    RVwys.buttonInsert.setEditLinkButton = target => {
        console.focus('RVwys.buttonInsert.setEditLinkButton');
        const isButton = RVwys.isButton;
        let check = isButton
            .attr('class')
            .match(
                /(isInternalPage|isWebsite|isEmail|isDownloadFile|isGetBookmark)/g
            );
        check !== null ? (check = check.toString()) : (check = false);

        !check
            ? $(isButton).addClass(`isButtonLink ${target}`)
            : $(isButton).removeClass(check).addClass(target);

        parent.$('#mini_buttonLinkUikit').trigger('click');

        $('.button-addlink').hide();
    };

    RVwys.buttonInsert.insertButtonPreset = (data, insertOpt) => {
        const beforeRange = RVwys.getRange();
        RVwys.insertHTML(data);
        const sel = RVwys.currentEditor.getSelection();
        sel.removeAllRanges();
        const newSel = RVwys.currentEditor.createRange();

        newSel.setStartAfter(data.get(0));
        sel.addRange(newSel);
        if (insertOpt) {
            RVwys.insertHTML('&nbsp;');
            sel.removeAllRanges();
            sel.addRange(beforeRange);
        }

        setTimeout(function () {
            RVwys.reSelectRange(beforeRange);
        }, 100);
    };

    RVwys.designViewAddEvent('mouseup', function (e) {
        parent.RVwys.isButton = false;
        RVwys.isButton = false;

        var curRange = $(e.target);
        var isButton = curRange.hasClass('rv-button');

        eventSetIsButton(curRange, isButton);
    });

    const eventSetIsButton = (curRange, isButton) => {
        if (isButton) {
            parent.RVwys.isButton = curRange;
            RVwys.isButton = curRange;

            parent
                .$('#auto-size')
                .on('change keyup keydown paste cut', 'textarea', function () {
                    $(this).height(0).height(this.scrollHeight);
                })
                .find('textarea')
                .change();
        } else {
            isButton = curRange.parent().hasClass('rv-button');
            curRange = curRange.parent();
            if (isButton) {
                eventSetIsButton(curRange, isButton);
            }
        }
    };

    RVwys.designViewAddEvent('mousedown', function (e) {
        RVwys.buttonInsert.clearSettingConfigure();

        const curRange = $(e.target);
        const isButton = curRange.hasClass('rv-button');

        $('.button-addlink').hide();

        if (isButton && parent.$('.wys-buttonInsert').is(':visible')) {
            parent.$('.wys-rowTwo').hide();
            parent.$('.wys-buttonInsert').show();
        } else {
            // parent.$('.wys-rowTwo').show() // ไม่ต้องใส่ไม่งั้นจะแสดง panel text ขึ้นบน image editor
            parent.$('.wys-buttonInsert').hide();
        }

        if (RVwys.isButton) parent.$('.ui-button-title').val(curRange.html());

        //get style inline to object
        let style = {};
        const attr = curRange.attr('style');

        if (typeof attr !== typeof undefined && attr !== false)
            style = CSSJSON.toJSONliteral(attr);
        else style = false;

        RVwys.buttonInsert.getAttrClass(
            curRange.prop('class').split(' '),
            style
        );
        //setConfigure on setting tab
        RVwys.buttonInsert.configureToSetting();
    });

    $(document).bind('designReady', () => {
        $('.buttonToEdit').click(function (e) {
            parent.$('.wys-rowTwo').hide();
            RVwys.buttonInsert.handlePanel('setting');
            //setConfigure on setting tab
            RVwys.buttonInsert.configureToSetting();
        });

        $('.linkToEdit').click(function () {
            if (RVwys.isButton) {
                RVwys.isButton.hasClass('rv-button') &&
                !RVwys.isButton.hasClass('isButtonLink')
                    ? $('.button-addlink').toggle()
                    : $('.button-addlink').hide();
            }
        });

        $('.add-button-link').click(function () {
            const targetAttr = $(this).attr('data-action');
            RVwys.buttonInsert.setEditLinkButton(targetAttr);
        });

        $('.buttonToClipboard').click(function (e) {
            const cmd = $(this).attr('cmd'),
                button = RVwys.isButton.get(0);
            console.log('buttonToClipboard');
            console.log(RVwys.isButton);
            console.log(button);
            console.log('----------:end');
            // $('<input id ="dummy">').val(button.outerHTML).appendTo('body').select()
            //button.execCommand(cmd)

            var sel = RVwys.currentEditor.getSelection();
            var newSel = RVwys.currentEditor.createRange();
            /**ต้องเรียกลำดับ range object ตามนี้ ไม่งั้นจะผิด */

            sel.removeAllRanges();
            newSel.selectNode(button);
            sel.addRange(newSel);
            document.execCommand(cmd);
            sel.removeAllRanges();
            $(RVwys.currentiFrame).focus();
            /**ต้องเรียกลำดับ range object ตามนี้ ไม่งั้นจะผิด */
            parent.console.pop.success({
                title: 'Success',
                text: 'Copied success CTRL + V to paste.',
                delay: 3000,
            });
        });

        parent.$('.rv-button-reset').click(function () {
            RVwys.buttonInsert.resetToDefault();
        });
    });

    $(document).bind('editorReady', () => {
        const frameBody = $('#frameBody').get(0);
        let frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
        if (frameBodyDoc.document) frameBodyDoc = frameBodyDoc.document;
        const tagHeaderiFrame = $(frameBodyDoc).contents().find('head');

        var parseWysiwygMixManifest = JSON.parse(parent.wex.wysiwygMixManifest);

        axios
            .get(
                `${parent.wex.url.WYS_IMG_URL}${parseWysiwygMixManifest['/css/buttonstyle.css']}`
            )
            .then(res => {
                const styleToJson = CSSJSON.toJSONliteral(res.data);
                RVwys.buttonInsert.sClass = styleToJson;
                RVwys.buttonInsert.appendCssToBody(
                    tagHeaderiFrame,
                    styleToJson
                );
            });
        $('#textButton').keyup(function () {
            // const map = { amp: '&', lt: '<', gt: '>', quot: '"', '#039': "'", nbsp: '&nbsp' }
            // let html = $(this).innerHTML.replace(/&([^;]+);/g, (m, c) => map[c])
            // this.innerHTML = html
            const html = $(this).val();
            if (parent.RVwys.isButton) {
                parent.RVwys.isButton.get(0).innerHTML = html;
            }
        });
        $('.widgetButton').click(function () {
            console.log('Event click : .widgetButton');
            RVwys.insertHTML($(this).clone());
            var data = $(this).clone();
            var insertOpt = true;
            if (RVwys.isButton) {
                RVwys.isButton.remove();
                insertOpt = false;
            }

            RVwys.buttonInsert.insertButtonPreset(data, insertOpt);
            RVwys.isButton = data;
            parent.RVwys.isButton = data;
        });

        $('.mini_insertButton').click(function () {
            parent.$('.wys-rowTwo').hide();
            RVwys.buttonInsert.handlePanel('design');
        });

        $('.rv-button-reset').click(function () {
            RVwys.buttonInsert.resetToDefault();
        });
    });
})(jQuery);
